import React, { ReactNode } from "react";
import { FiCheck } from "react-icons/fi";
import { Checkbox as ChakraCheckbox } from "@chakra-ui/react";

export interface CheckboxWithLabelBaseProps {
	name?: string;
	checked?: boolean;
	checkmarkTop?: string;
	children?: ReactNode;
	className?: string;
	error?: string;
	fontSize?: string;
	initialValue?: boolean;
	label?: string;
	required?: boolean;
	style?: React.CSSProperties;
	touched?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CheckboxWithLabel: React.FC<CheckboxWithLabelBaseProps> = ({
	children,
	label,
	className,
	style,
	checkmarkTop = "0",
	fontSize,
	initialValue = false,
	onChange,
	checked,
	name,
	required = false,
}) => {
	const [isChecked, setIsChecked] = React.useState(initialValue);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setIsChecked(e.target.checked);
		if (onChange) {
			onChange(e);
		}
	};

	const checkedValue = checked !== undefined ? checked : isChecked;

	return (
		<label
			htmlFor={name}
			className={`mb-4 relative flex items-center gap-2 cursor-pointer ${className || ""}`}
			style={style}
		>
			<ChakraCheckbox
				type="checkbox"
				isChecked={checkedValue}
				onChange={handleChange}
				name={name}
				id={name}
				className="absolute opacity-0 cursor-pointer"
			/>
			<span
				className="shrink-0 h-[19px] w-[19px] bg-gray-200 border border-gray-300 rounded-sm block transition-all duration-200 ease-in-out hover:bg-gray-300 relative"
			>
				{checkedValue && (
					<span className="absolute inset-0 bg-blue-600 rounded-sm border-0 flex items-center justify-center">
						<FiCheck className="text-white w-3 h-3" strokeWidth={3} />
					</span>
				)}
			</span>
			{(label || children) && (
				<span className={`select-none ${fontSize ? "" : "text-sm"} text-gray-700`}>
					{label}
					{required && <span className="text-red-500 ml-0.5">*</span>}
					{children}
				</span>
			)}
		</label>
	);
};